import { DOMCarousel, DOMCarouselItem } from "../umadash.js/view/DOMCarousel";
import { SectionWatcher } from "../umadash.js/util/SectionWatcher";
import { WindowWatcher } from "../umadash.js/util/WindowWatcher";
import { GameCarouselItem } from "./view/GameCarouselItem";
import { GlobalHeader } from "./view/GlobalHeader";
import { MenuType } from "./enum/MenuType";
import { SmoothScroll } from "../umadash.js/util/SmoothScroll";
import { DeviceUtil } from "./util/DeviceUtil";
import { SnsUtil } from "../umadash.js/util/SnsUtil";
import { SimpleSlideshow } from "../umadash.js/view/SimpleSlideshow";
import { SnsChanger } from "./util/SnsChanger";

const $ = require('jquery');

export class EntryHome {

    private carousels?: DOMCarousel<DOMCarouselItem>[];
    private slideshows: SimpleSlideshow[];

    private sectionWatcher: SectionWatcher;
    private scrollHandler: () => void;
    private resizeHandler: () => void;

    constructor() {
        
        this.init();
    }

    public run(): void {

        

        SnsChanger.changeShareUrl(false);

        // Snsをオン
        SnsUtil.enable(
            $('.btnRound--facebook, .btnCircle--facebook'),
            $('.btnRound--twitter, .btnCircle--twitter'),
            $('.btnRound--hatena'),
            $('.btnRound--line')
        );

        // スムーススクロールをオン
        SmoothScroll.attach();
        

        // カルーセルの起動
        for (let i = 0, length = this.carousels.length; i < length; i += 1) {
            const carousel: DOMCarousel<DOMCarouselItem> = this.carousels[i];
            carousel.show();
            carousel.start();
        }

        // スライドショー
        for (let i = 0, length = this.slideshows.length; i < length; i += 1) {
            const slideshow: SimpleSlideshow = this.slideshows[i];
            slideshow.start();
        }

        // スクロール監視
        WindowWatcher.startWatchingScroll(this.scrollHandler, '', 0, false);
        this.scroll();

        // リサイズ監視
        WindowWatcher.startWatchingResize(this.resizeHandler, '', 0, false);
    }

    private scroll(): void {
        const scrollTop: number = WindowWatcher.getScrollTop();
        this.sectionWatcher.updateByScroll(scrollTop);
    }

    private resize(): void {
        for (let i = 0, length = this.carousels.length; i < length; i += 1) {
            const carousel: DOMCarousel<DOMCarouselItem> = this.carousels[i];
            carousel.resize();
        }        
    }

    private init(): void {

        // bind
        this.scrollHandler = this.scroll.bind(this);
        this.resizeHandler = this.resize.bind(this);

        // タブレットの場合はビューポートを書き換え
        if (window['device'].tablet()) {
            $("meta[name=viewport]").attr("content", 'width=1280');
        }
        
        SmoothScroll.offset = DeviceUtil.isPc() ? -100 : -50;

        // カルーセル
        const margin: number = DeviceUtil.isPc() ? 20 : 26;
        const $carousels: JQuery = $('.carousel');
        if ($carousels.length > 0) {
            this.carousels = [];
            $carousels.each((index: number, element: HTMLElement) => {
                const $elm:JQuery = $(element);
    
                const c: DOMCarousel<GameCarouselItem> = new DOMCarousel(
                    $(element), margin, false,
                    // アイテムを追加する関数
                    () => {
                        return new GameCarouselItem();
                    }
                );
                this.carousels.push(c);
            });
        }

        // スライドショー
        const $slideshows: JQuery = $('.js-simpleSlideshow');
        if ($slideshows.length > 0) {
            this.slideshows = [];
            $slideshows.each((index: number, element: HTMLElement) => {
                const $elm:JQuery = $(element);
                const s: SimpleSlideshow = new SimpleSlideshow($elm);
                this.slideshows.push(s);
            });
        }

        // ポジションマネージャ
        const sWatcher = new SectionWatcher($('.js-section'));
        sWatcher.addEventListener(SectionWatcher.Change, () => {
            const index: number = this.sectionWatcher.getCurrentIndex();
            GlobalHeader.getInstance().setCurrentMenu(index);
        });
        this.sectionWatcher = sWatcher;   
    }
}